





































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import store from '@/store';

@Component({
  computed: mapState([
    'categories',
    'filterTags',
  ]),
})
export default class Modal extends Vue {
    categories!: Array<string>;

    filterTags!: Array<string>;

    // eslint-disable-next-line class-methods-use-this
    hideModal() {
      const modal = document.querySelector('#filter-modal') as Element;
      modal.classList.remove('is-active');
    }

    // eslint-disable-next-line class-methods-use-this
    toggleCategory(category: string) {
      store.dispatch('toggleCategory', category);
    }
}
